import { useParams } from "react-router-dom";

import { cn } from "@/lib/helpers/cn";
import type { DiagnosisEntry, UUID } from "@/core/types";

import { usePatientDiagnosis } from "../../api/queries/usePatientDiagnosis";

import { PatientData } from "./PatientData";

function formatDiagnosis(entries: DiagnosisEntry[] | undefined): string {
  if (!entries?.length) return "None";

  return entries.map((e) => e.value).join(", ");
}

export function PatientDiagnosis() {
  const { patientId } = useParams<{ patientId: UUID }>();
  const { data } = usePatientDiagnosis({ patientId });

  return (
    <dl
      className={cn(
        "tw:flex tw:flex-col tw:gap-2.5 tw:lg:px-4 tw:lg:py-4",
        "tw:max-lg:grid-flow-row tw:max-lg:content-stretch",
        "tw:lg:border-x tw:lg:border-stroke-quaternary",
      )}
    >
      <PatientData label="Primary Diagnosis">
        {formatDiagnosis(data?.ICD_10_axis_1_diagnosis)}
      </PatientData>

      <PatientData label="Secondary Diagnosis">
        {formatDiagnosis(data?.ICD_10_axis_2_diagnosis)}
      </PatientData>
    </dl>
  );
}
